import getHtmlParam from '../../utilities/htmlParam';

const param = getHtmlParam('.js-param .param');

export class StickyPDA {
  init() {
    const stickyCta = () => {
      if(document.querySelector('.pda-cta-buttons')) {
        const mediaMobileV2 = window.matchMedia('(max-width: 767px)');
        const ctaButtonHeight = (document.querySelector('.pda-cta-buttons') as HTMLElement).offsetHeight;
        const ctaButtonOffset = (document.querySelector('.pda-cta-buttons') as HTMLElement).getBoundingClientRect().top + window.scrollY - (document.querySelector('header.head') as HTMLElement).offsetHeight;
        const showStickyOffset = ctaButtonHeight + ctaButtonOffset;
        const scrollTop = window.pageYOffset;

        if (scrollTop >= showStickyOffset || mediaMobileV2.matches) {
          document.body.classList.add('pda-sticky');
          (document.querySelector('.pda-sticky-cta-box') as HTMLElement).style.display = 'block';
        }

        if (scrollTop < showStickyOffset && !mediaMobileV2.matches) {
          document.body.classList.remove('pda-sticky');
          (document.querySelector('.pda-sticky-cta-box') as HTMLElement).style.display = 'none';
        }
      }
    };

    stickyCta();

    window.addEventListener('scroll', () => {
      stickyCta();
    });

    // sticky on ready
    const articleTitle = document.getElementById('article-title').innerHTML;
    const pdaStickyCta = document.querySelector('.pda-sticky-cta');
    if (pdaStickyCta) {
      document.querySelector('.pda-sticky-title h3').innerHTML = articleTitle;
      const prcOffer = document.querySelector(".prc-article .prc-offer");
      const prcListInfo = document.querySelector(".prc-article .prc-list-info");
      pdaStickyCta.querySelector('.prc-article-offer').innerHTML = prcOffer && prcOffer.innerHTML;
      pdaStickyCta.querySelector('.prc-article-unit').innerHTML = prcListInfo && prcListInfo.innerHTML;
      const picture = document.querySelector('#pda-gallery-hero [data-article-id="' + param.get("selectedItem") + '"]');
      picture && (document.querySelector('.pda-sticky-cta-box .article-name picture').innerHTML = picture.innerHTML);

      const stickyPriceBasePrice = document.querySelector('.pda-sticky-cta .prc-baseprice');
      const PriceBasePrice = document.querySelector('.pda-cta-price .prc-baseprice');
      PriceBasePrice && stickyPriceBasePrice && (stickyPriceBasePrice.innerHTML = PriceBasePrice.textContent);
    }
  }
}

export class StickyPUES {
  init() {

    // function to calculate element offsets and set body class for sticky pues search rating form
    function stickyPues() {
      const wrapper:HTMLElement = document.querySelector('.results-wrapper .product-sorting');
      const ratingContainer:HTMLElement = document.querySelector('.rating-container');
      const header:HTMLElement = document.querySelector('header.head .header-main');

      const wrapperOffset = wrapper.getBoundingClientRect().top + window.scrollY;
      const ratingOffset = ratingContainer.getBoundingClientRect().top + window.scrollY - window.innerHeight;
      const headerHeight = header.offsetHeight;

      if((window.scrollY > wrapperOffset - headerHeight && window.scrollY < ratingOffset)) {
        document.body.classList.add('pues-rating-sticky');
      } else {
        document.body.classList.remove('pues-rating-sticky');
      }
    }

    if(document.querySelector('.rating-container') && document.querySelector('.results-wrapper .product-sorting') && document.querySelector('header.head')) {

      if(sessionStorage.getItem('pues-rating-hidden') != '1') {
        window.addEventListener('scroll', stickyPues);
      }

      const closeBtn = document.querySelector('.rating-container .close-btn');

      closeBtn && closeBtn.addEventListener('click', function () {
        document.body.classList.remove('pues-rating-sticky');
        sessionStorage.setItem('pues-rating-hidden', '1');

        window.removeEventListener('scroll', stickyPues);
      });

      const formButton = document.querySelector('.pues-rating-submit');

      formButton.addEventListener('click', function () {
        setTimeout(function () {
          document.body.classList.remove('pues-rating-sticky');
          window.removeEventListener('scroll', stickyPues);
        }, 3000)
      })
    }
  }
}

export class StickyMobileFilter {
  init() {
    const wrapper:HTMLElement = document.querySelector('.pues .product-sorting');
    const ratingContainer:HTMLElement = document.querySelector('.rating-container');
    const header:HTMLElement = document.querySelector('header.head .header-main');
    const stickyEl:HTMLElement = document.querySelector('.filter-toggle-wrapper')
    const filterWrapper:HTMLElement = document.querySelector('.filter-wrapper');

    let oldScrollYPos = window.scrollY;
    let scrollUp = false;

    // function to calculate element offsets and set body class for sticky filter and category buttons on mobile
    // and set fixed height on filter-wrapper to compensate for height change if child is sticky
    function stickyMobileFilter() {
      const wrapperOffset = wrapper.getBoundingClientRect().top + window.scrollY;
      const headerHeight = header.offsetHeight;
      const ratingOffset = ratingContainer && ratingContainer.getBoundingClientRect().top + window.scrollY - window.innerHeight + headerHeight;

      scrollUp = oldScrollYPos >= window.scrollY;
      oldScrollYPos = window.scrollY;

      if(window.scrollY > wrapperOffset - headerHeight && window.scrollY < ratingOffset && scrollUp) {
        document.body.classList.add('filter-mobile-sticky');
        stickyEl.style.top = headerHeight + 'px';
        filterWrapper.style.height = filterWrapper.offsetHeight + 'px';
      } else {
        document.body.classList.remove('filter-mobile-sticky');
        stickyEl.style.top = 'auto';
        filterWrapper.style.height = "100%";
      }
    }
    window.addEventListener('scroll', stickyMobileFilter);
  }
}
